import { createPortal } from 'react-dom';
import { usePageData } from '@/contexts/pageContext';
import { PromoBadge } from '@/components/PromoBadge';

const promoBadgePortal = document.querySelector(
  '.product__images__image-container',
);

export const usePromoBadge = () => {
  console.log(promoBadgePortal);
  const { product } = usePageData();

  return promoBadgePortal && product?.promoBadge
    ? createPortal(
        <PromoBadge
          altText={product.promoBadge.altText}
          src={product.promoBadge.src}
        />,
        promoBadgePortal,
      )
    : null;
};
